import { useEffect, useState } from "react";
import axios from "axios";
import { API, authHeaders } from "./adminAuth";

// ---------- Public ----------
export const useHolidayActive = () => {
  const [state, setState] = useState(null);
  useEffect(() => { getActiveHoliday().then((d) => setState(!!d.program_active)).catch(() => setState(false)); }, []);
  return state;
};
export const getActiveHoliday = () =>
  axios.get(`${API}/holiday/active`).then((r) => r.data);

export const submitHolidayOrder = (body) =>
  axios.post(`${API}/holiday/orders`, body).then((r) => r.data);

// ---------- Admin ----------
const h = () => ({ headers: authHeaders() });
export const listHolidayOrders = () =>
  axios.get(`${API}/holiday/orders`, h()).then((r) => r.data);
export const setHolidayOrderStatus = (id, status) =>
  axios.patch(`${API}/holiday/orders/${id}/status`, { status }, h()).then((r) => r.data);
export const updateHolidayOrder = (id, body) =>
  axios.patch(`${API}/holiday/orders/${id}`, body, h()).then((r) => r.data);
export const resendHolidayEmail = (id, which) =>
  axios.post(`${API}/holiday/orders/${id}/resend`, { which }, h()).then((r) => r.data);
export const updateHolidayItemArtwork = (id, index, body) =>
  axios.patch(`${API}/holiday/orders/${id}/items/${index}/artwork`, body, h()).then((r) => r.data);
export const uploadHolidayArtworkFile = (id, index, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/holiday/orders/${id}/items/${index}/artwork_file`, fd,
    { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const fetchHolidayArtworkBlob = (fileUrl) =>
  axios.get(`${API}${fileUrl.replace("/api", "")}`, { ...h(), responseType: "blob" }).then((r) => r.data);
export const getHolidayReporting = (days) =>
  axios.get(`${API}/holiday/reporting?days=${days}`, h()).then((r) => r.data);
export const setHolidayOrderNumber = (id, vg_order_number) =>
  axios.patch(`${API}/holiday/orders/${id}/order-number`, { vg_order_number }, h()).then((r) => r.data);
export const listHolidayCollections = () =>
  axios.get(`${API}/holiday/collections`, h()).then((r) => r.data);
export const updateHolidayProgram = (b) =>
  axios.patch(`${API}/holiday/program`, b, h()).then((r) => r.data);
export const updateHolidayCollection = (id, b) =>
  axios.patch(`${API}/holiday/collections/${id}`, b, h()).then((r) => r.data);

export const HOLIDAY_ORDER_STATES = [
  "New", "Artwork Review", "Awaiting Customer", "Production Ready",
  "In Production", "Completed", "On Hold", "Cancelled",
];
export const HOLIDAY_ASSIGNEES = ["Unassigned", "Customs", "Art", "Sales", "Production"];
export const HOLIDAY_PERSONALIZATION_TYPES = ["Family Name", "Business Name", "Location Name", "Welcome Message", "Custom Message", "Logo + Text", "Other"];
export const HOLIDAY_ARTWORK_STATES = ["Not Started", "In Progress", "Proof Sent", "Approved", "Revisions Requested"];
export const HOLIDAY_WAITING = ["None", "Internal", "Customer"];
export const HOLIDAY_WAITING_REASONS = ["Proof Approval", "Artwork Question", "Pricing", "Customer Information", "Production Information", "Other"];
